import { Map } from "immutable";

import {
  compose,
  connect,
  toJS
} from "seneca-common/components/container-utils";
import {
  validateConsent,
  validateDropdownField
} from "seneca-common/utils/functions/validationFunctions";

import { getIncludeYearGroup } from "features/regions/selectors";
import { userAccountType } from "features/user/consts";

import makeReduxFormWrapper from "../../containers/makeSignUpDetailsReduxFormWrapper";
import SignUpFormStudentDetails from "./SignUpFormStudentDetails";

const validateStudents = (valuesIn: Map<string, string>, props: any) => {
  const { consent, yearGroup } = valuesIn.toJS() as any;

  if (props.collectUserYearGroup) {
    return {
      consent: validateConsent(consent),
      yearGroup: validateDropdownField("year group")(yearGroup)
    };
  }

  return {
    consent: validateConsent(consent)
  };
};

const getStudentFormDetails = (formValues: any) => {
  const details: Record<string, any> = {
    type: userAccountType.schoolstudent
  };

  const yearGroup = formValues.get("yearGroup");

  if (yearGroup) {
    details.yearGroup = yearGroup;
  }

  const schoolId = formValues.getIn(["school", "schoolId"]);
  if (schoolId) {
    details.schoolId = schoolId;
  }

  const guardianEmail = formValues.get("guardianEmail");

  if (guardianEmail) {
    details.guardianEmail = guardianEmail;
  }

  return details;
};

const reduxFormConnector = makeReduxFormWrapper(
  validateStudents,
  getStudentFormDetails
);

const mapStateToProps = (state: any) => ({
  collectUserYearGroup: getIncludeYearGroup(state)
});

const ConnectedSignUpFormStudentDetails = compose(
  connect(mapStateToProps),
  // @ts-ignore
  toJS,
  reduxFormConnector
  // @ts-ignore
)(SignUpFormStudentDetails);

export default ConnectedSignUpFormStudentDetails;
